module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw Teaser2-rw exclude-auto-rw page-open-right-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter25"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block39"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TOC"
    }
  }, [_vm._v("Chapter One")])])]), _vm._v(" "), _c('div', {
    staticClass: "block-rw",
    attrs: {
      "id": "communication-letter4"
    }
  }, [_c('p', {
    staticClass: "salute-rw",
    attrs: {
      "id": "salute1"
    }
  }, [_c('i', [_vm._v("My Dearest Brenner,")])]), _vm._v(" "), _c('p', {
    staticClass: "l-rw",
    attrs: {
      "id": "p3205"
    }
  }, [_c('i', [_vm._v("You will forgive a friend of long-standing for not using your newly acquired honorific. Old habits die hard, though I suppose even an Irish barony is due an occasional nod. In ten or twenty years, perhaps, I will acquire the habit of addressing you as my lord. Perhaps not. In any case, I hope this letter finds you well and anticipating the holidays—or the holiday wassail—with much joy.")])]), _vm._v(" "), _c('p', {
    staticClass: "l-rw",
    attrs: {
      "id": "p3206"
    }
  }, [_c('i', [_vm._v("The time has come for you to repay that small favor I did you several years ago—the favor that resulted in you eluding capture, torture, and death at the hands of our then-enemies. My request is laughably simple to accomplish for a man of your skills, which is fortunate, for the matter has become urgent. My solicitors tell me I’m in want of a wealthy wife. One must approach the matrimonial lists confident that no stain will mar one’s bachelor escutcheon in the eyes of prospective in-laws.")])]), _vm._v(" "), _c('p', {
    staticClass: "l-rw",
    attrs: {
      "id": "p3207"
    }
  }, [_c('i', [_vm._v("Did I ever tell you that I deserve sole credit for raising the celebrated Henrietta Whitlow from the status of bumbling housemaid to consort of dukes and nabobs? The tale impresses even me, who more or less wrote it…")])]), _vm._v(" "), _c('p', {
    staticClass: "l-rw",
    attrs: {
      "id": "p3208"
    }
  }, [_c('i', [_vm._v("Henrietta Whitlow—a bumpkin’s name, of a certainty—joined my domestic staff shortly after I came down from university. A more shy, unworldly, backward creature you never met. She took pride in blacking the andirons and in polishing ")]), _c('i', [_vm._v("the candlesticks. She took pride in shining the windows until every parlor reeked of vinegar. She took a painful degree of pride in every domestic chore imaginable, but no pride whatsoever in herself. I changed all of that, though it was a thankless and tedious chore…")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-rw",
    attrs: {
      "id": "p3209"
    }
  }, [_c('span', {
    staticClass: "raisedcap-rw"
  }, [_vm._v("I")]), _vm._v(" tell you, John Coachman, there is no room at this inn!” The innkeeper banged a palm on the counter, as if knocking down goods at auction.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3210"
    }
  }, [_vm._v("The coachman, a substantial specimen of middle years, leaned forward so he was nose to nose with the innkeeper.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3211"
    }
  }, [_vm._v("“Your stable is nearly empty,” he said, a Scots burr in every syllable. “Your common room boasts exactly one gentleman awaiting a meal, and you "), _c('i', [_vm._v("will")]), _vm._v(" find accommodations for my lady.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3212"
    }
  }, [_vm._v("Lord Michael Brenner, Baron Angelford, the gentleman in question, sat before the common’s largest window, which was close enough to the foyer that he heard every word of the argument between the coachman and the innkeeper. Beyond the window, an enormous traveling coach with spanking yellow wheels and four matched chestnuts stood in the yard. The horses’ breath blew white in the frigid air, and one of the wheelers stomped a hoof against frozen ground.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3213"
    }
  }, [_vm._v("No crest on the coach door, but considerable fine luggage lashed to the roof. Why would an innkeeper with rooms aplenty turn away a wealthy customer?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3214"
    }
  }, [_vm._v("“I’m expecting other parties,” the innkeeper said. “Decent folk who expect decent accommodations.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3215"
    }
  }, [_vm._v("A woman emerged from the coach. She was attired in a brown velvet cloak with a cream wool scarf about her neck and ears. She was tall and, based on her nimble descent, young. The second woman, a shorter, rounder specimen in a gray cloak, emerged more slowly and teetered to the ground on the arm of a footman.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3216"
    }
  }, [_vm._v("What self-respecting innkeeper refused accommodations to two women, at least one of whom was quite well-to-do? Michael waited for a drunken lordling or two to stagger from the coach, or one of London’s more notorious gamblers—he knew them all—but the footman closed the coach door.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3217"
    }
  }, [_vm._v("The taller woman removed her scarf and wrapped it about her companion. Michael caught a glimpse of flaming red hair before the awning over the inn’s front door obscured the women from view.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3218"
    }
  }, [_c('i', [_vm._v("Ah, well then.")]), _vm._v(" The puzzle began to make sense.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3219"
    }
  }, [_vm._v("“If you’re expecting other parties,” the coachman said, “they won’t be underfoot until sundown. My lady needs a room for only a few hours, while I find a blacksmith to reset a shoe on my off-side leader.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3220"
    }
  }, [_vm._v("“My guests might arrive at any moment,” the innkeeper shot back. “The sky promises snow, and I don’t give reserved rooms away.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3221"
    }
  }, [_vm._v("The front door opened, an eddy of cold air reaching even into the common room.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3222"
    }
  }, [_vm._v("“He’s being difficult, ma’am,” the coachman said to the red-haired woman. “I’ll make the cheating blighter see reason.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3223"
    }
  }, [_vm._v(" “Mr. Murphy’s difficult demeanor is one of the reliable institutions on this delightful route,” the lady said. “Rather like the potholes and not quite as inconvenient as the highwaymen. Fortunately, Mrs. Murphy’s excellent housekeeping is equally trustworthy. How much, Mr. Murphy?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3224"
    }
  }, [_vm._v("The woman’s tone was cultured and amused, but also just a shade too low, a touch too knowing. Had the common been full of men, every one of them would have eavesdropped on the conversation because her voice was that alluring.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3225"
    }
  }, [_vm._v("“No amount of coin will produce an extra room,” Murphy retorted. “Your kind think everything can be bought, but I run a proper establishment.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3226"
    }
  }, [_vm._v("“"), _c('i', [_vm._v("My kind")]), _vm._v(" is simply a cold, tired traveler far from home and willing to pay for warmth and privacy. A room, please.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3227"
    }
  }, [_vm._v("Coin slid across the counter. Murphy watched the lady’s gloved hand and then studied the gold glinting up from the worn wood.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3228"
    }
  }, [_vm._v("“I told you after your last visit, Henrietta Whitlow, you are not welcome here. Now be off with you.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3229"
    }
  }, [_vm._v("“And you call yourself an innkeeper,” the coachman sneered. “A woman willing to pay you good coin for a short respite from the elements, and you send her back out into the cold when anybody—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3230"
    }
  }, [_vm._v("“Excuse me,” Michael said, rising from his table and joining the group at the front desk. “I couldn’t help but overhear. Miss Whitlow is welcome to use my rooms.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3231"
    }
  }, [_vm._v("“But, sir!” Murphy expostulated. “You don’t know to whom you’re offering such a kindness. I have good, substantial reasons for not allowing just anybody to bide under this roof.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3232"
    }
  }, [_vm._v("Michael well knew to whom the innkeeper was being so rude.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3233"
    }
  }, [_vm._v("He passed Miss Whitlow’s coins to the coachman. “The holidays are upon us, Mr. Murphy, which means the weather is unpredictable, and travel is both dangerous and trying. The lady and her companion are welcome to use the parlor connected to my bedchamber. The hospitality extended is not yours, but mine, and as my guests, you will please show them every courtesy. Miss Whitlow.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3234"
    }
  }, [_vm._v("He bowed to the redhead, who executed a graceful curtsey in response. Her companion had come inside and watched the goings-on in unsmiling silence.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3235"
    }
  }, [_vm._v("“My thanks,” Miss Whitlow said. “Though to whom am I expressing my gratitude?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3236"
    }
  }, [_vm._v("“Michael Brenner, at your service. Mr. Murphy, the ladies will take a meal and a round of toddies in your private parlor once they’ve refreshed themselves above stairs. John Coachman and madam’s staff will similarly need sustenance and hospitality. Do I make myself clear?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3237"
    }
  }, [_vm._v("Murphy scowled at Miss Whitlow, who regarded him with the level stare of a cat deciding whether the menu would feature mouse, songbird, or fricassee of innkeeper.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3238"
    }
  }, [_vm._v("The scandal sheets and tattlers didn’t do Henrietta Whitlow justice. Her features were just one degree off from cameo perfection—her nose a shade too aquiline, her mouth too full, her eyebrows a bit too dramatic, her height an inch too grand—and the result was unforgettable beauty. Michael had seen her from a distance at the theater many times, but up close, her impact was… more than physical.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3239"
    }
  }, [_vm._v("Duels had been fought over Henrietta Whitlow, fortunes wagered, and her amatory skills had become the stuff of legend.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3240"
    }
  }, [_vm._v("“Mr. Brenner, might I invite you to join us?” Miss Whitlow asked. “You are our host, after all, and good company always makes time pass more pleasantly.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3241"
    }
  }, [_vm._v("The invitation was bold but, at a coaching inn, not outlandishly improper.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3242"
    }
  }, [_vm._v("“I was awaiting my own midday meal,” Michael said. “I’ll be happy to join you.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3243"
    }
  }, [_vm._v("Michael’s day had been laid out according to a careful plan, but plans changed, and opportunities sometimes came along unlooked for. A man didn’t have a chance to share a meal with London’s most sought-after courtesan every day, and Michael had been growing damned hungry waiting for Murphy to produce a bowl of soup and some bread.")]), _vm._v(" "), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration18"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p3244"
    }
  }, [_vm._v("*  *  *")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3245"
    }
  }, [_vm._v("Nothing about Lord Angelford’s demeanor suggested he expected Henrietta to repay his kindness with intimate favors, though she knew better than to trust him. British gentlemen were randy creatures, particularly wealthy, titled British gentlemen.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3246"
    }
  }, [_vm._v("His lordship had chosen not to mention that title. Henrietta and Angelford hadn’t been introduced, but Michael Brenner would soon learn that newly minted barons had almost as little privacy as courtesans.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3247"
    }
  }, [_vm._v("His lordship was tall and handsome, though not precisely dark. His hair was auburn, and his voice bore a hint of Ireland overlaid with plenty of English public school. He was exquisitely attired in tall boots, breeches, brown riding jacket, and fine linen, and his waistcoat was gold with subtle green embroidery vining throughout.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3248"
    }
  }, [_vm._v("Newly titled, but a lord to the teeth already. Such men took good care of their toys, from snuffboxes, to hunters, to dueling pistols, to mistresses.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3249"
    }
  }, [_vm._v("Henrietta was heartily sick of being a well-cared-for toy.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3250"
    }
  }, [_vm._v("Lord Angelford ushered her into a cozy parlor with a blazing fire and a dining table set for four. Lucille trundled along as well—she was fiercer than any mastiff when it came to Henrietta’s safety—and passed Henrietta her scarf.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3251"
    }
  }, [_vm._v("“If madam will excuse me,” Lucille said, “I’ll step upstairs for a moment while we’re waiting for a meal.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3252"
    }
  }, [_vm._v("“Take your time,” Henrietta replied, then fell silent as Lucille bustled off. A courtesan excelled at conversation, Henrietta was exhausted, however, and fatigue predisposed her to babbling. A self-possessed quiet was always a far better course than babbling.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3253"
    }
  }, [_vm._v("“May I take your cloak?” his lordship asked.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3254"
    }
  }, [_vm._v("“Of course.” She passed him her scarf, then undid the frogs of her cloak and peeled it from her shoulders. In London, Henrietta would have made sure to gild the moment with a brush of fingers or a lingering gaze, because a courtesan never knew who her next protector might be.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3255"
    }
  }, [_vm._v("London, thank the Almighty and John Coachman’s skill, was many snowy miles to the south. Henrietta hoped never to see its smoky, crowded, noisy like again.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3256"
    }
  }, [_vm._v("Nothing in Angelford’s gaze lingered—another small mercy. After he hung Henrietta’s cloak and scarf on the hooks on the back of the door, he held a chair for her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3257"
    }
  }, [_vm._v("“Have you far to go?” he asked, taking the opposite seat. He’d put Henrietta closest to the fire, and the heat was heavenly.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3258"
    }
  }, [_vm._v("“Another day or so, weather permitting. What of yourself?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3259"
    }
  }, [_vm._v("The distance Henrietta wished to travel, from the pinnacle of the demimonde clear back to respectability, was far indeed. Some had managed, such as Charles Fox Pitt’s widow, but she’d taken years and years to accomplish that feat and had called upon a store of charm Henrietta could only envy.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3260"
    }
  }, [_vm._v("“I am traveling to my estate in Oxfordshire,” his lordship said, “and tending to some business along the way. Will you celebrate the holidays with family?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3261"
    }
  }, [_vm._v(" Henrietta’s brothers and their wives hadn’t cut her off, but Papa was another matter. “My plans are as yet unconfirmed. Have we met before, Mr. Brenner?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3262"
    }
  }, [_vm._v("She wanted the dangling sword of her former occupation either cut loose from over her head, or plunged into her already bleak mood.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3263"
    }
  }, [_vm._v("Damn the holidays anyway.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3264"
    }
  }, [_vm._v("“We have not been introduced, though I’m sure we have mutual acquaintances. The Duke of Anselm and I have invested in the same ventures on occasion.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3265"
    }
  }, [_vm._v("Henrietta’s last protector, and the best of a curious lot. His Grace was married now, and happily so.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3266"
    }
  }, [_vm._v("The varlet.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3267"
    }
  }, [_vm._v("“Then you are aware of my reputation, "), _c('i', [_vm._v("your lordship")]), _vm._v(". If you’d prefer my maid and I dine without you, I’ll understand.” Henrietta wished he’d go strutting on his handsome way. Men either wanted something from her, or reproached her for what other men paid handsomely to take from her. The hypocrisy was as stunning as it was lucrative.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3268"
    }
  }, [_vm._v("“Miss Whitlow, I make it a habit not to judge people on the strength of reputation. Too often, public opinion is based on hearsay, anecdote, and convenience, and when one meets the object of gossip in person, the reality is either disappointing or dismaying. The beef stew here is above reproach, though I’ve sustained myself mainly on bread, cheese, and ham.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3269"
    }
  }, [_vm._v("A serving maid brought in a tray of toddies, and the scent alone nearly made Henrietta weep. She was cold, exhausted, angry, and should not be taking spirits, but these toddies would be scrumptious.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3270"
    }
  }, [_vm._v("“I asked you to join me for the meal,” she said, “so Murphy would not serve me boiled shoe leather with a side of week-old cabbage. You mustn’t think me hospitable.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3271"
    }
  }, [_vm._v("His lordship set a steaming toddy before her. “I think you tired, chilled, and in need of a meal. As it happens, so am I. Happy Christmas, Miss Whitlow.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3272"
    }
  }, [_vm._v("He touched his glass to hers and waited for Henrietta to take a sip of hot, sweet, spicy heaven. The spirits were good quality—not fit for a duke, but fit for a retired courtesan. When his lordship launched into a discourse about the potential for increased legal trade in Scottish whisky—of all the undrinkable offenses to pleasurable dining—Henrietta wondered if the baron might be that rarest of specimens, the true British gentleman.")]), _vm._v(" "), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration19"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p3273"
    }
  }, [_vm._v("*  *  *")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3274"
    }
  }, [_vm._v("Michael was already engaged in thievery, a skill he’d hoped never to rely on again. He was stealing the trust of a woman who would doubtless prefer he take her last groat or the clothes off her back. He didn’t need her money, and he didn’t want her trust.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3275"
    }
  }, [_vm._v("The yearning to remove the clothes from her back filled him with a combination of self-loathing, amusement, and wistfulness.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3276"
    }
  }, [_vm._v("“Happy Christmas, your lordship,” Miss Whitlow said, taking a sip of her toddy. “Why did you introduce yourself without the title?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3277"
    }
  }, [_vm._v("He hadn’t noticed that blunder—for it was a blunder. “Habit,” Michael said, which was the damned sorry truth. “My last employer was of such consequence he could command favors from the sovereign. A barony was the marquess’s way of thanking me for years of loyal service, or so he claimed.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3278"
    }
  }, [_vm._v("Miss Whitlow held her drink in both hands, and even that—the way she cradled a goblet of hot spirits with pale, unadorned fingers—had a sensual quality.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3279"
    }
  }, [_vm._v("“You refer to the Marquess of Heathgate,” Miss Whitlow said. “A refreshingly direct man, in my experience, and he hasn’t a vain bone in his body. My path hasn’t crossed his for years.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3280"
    }
  }, [_vm._v("Arrogant, Lord Heathgate certainly was, but the lady was right—the marquess was not vain. “What you call direct, others have deemed shockingly ungenteel. I suspect hanging a title about my neck was Heathgate’s way of getting even for my decision to leave his employ. A joke, by his lights.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3281"
    }
  }, [_vm._v("She traced her finger about the rim of her glass, and Michael would have sworn the gesture was not intended to be seductive.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3282"
    }
  }, [_vm._v("“The marquess’s jest has not left you laughing, my lord.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3283"
    }
  }, [_vm._v("If he asked her to call him Michael, she’d probably leave the table, if not the inn. “When I turned in my notice, the marquess wasn’t laughing either.” Though Heathgate had probably known Michael was contemplating a departure before Michael had admitted it to himself. They’d been a good fit as lord and lackey, a rarity for them both, particularly prior to the marquess’s marriage.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3284"
    }
  }, [_vm._v("Miss Whitlow took another leisurely sip of her drink. “Is this where you lament the terrible burden placed upon you by wealth, consequence, and the sovereign’s recognition?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3285"
    }
  }, [_vm._v("Mother Mary, she was bold, but then, a courtesan had to be. “I was born bog Irish, Miss Whitlow. You could hang a dukedom on me, and the stink of peat would still precede me everywhere. I respect coin of the realm as only one who’s done without it can, but I don’t give a counterfeit farthing for titles, styles, or posturing.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3286"
    }
  }, [_vm._v("The maid intruded again, this time bearing bowls of steaming soup, a small loaf of bread, and a tub of butter.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3287"
    }
  }, [_vm._v("She’d bobbed half a curtsey and headed for the door when Michael thought to ask, “Would you like a pot of tea, Miss Whitlow? Or chocolate, perhaps?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3288"
    }
  }, [_vm._v("“Tea would be lovely. Gunpowder, if it’s available.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3289"
    }
  }, [_vm._v("He would have taken her for a hot chocolate sort of a woman, but he liked that she’d surprised him. So few people did.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3290"
    }
  }, [_vm._v("“If titles, styles, and posturing don’t earn your respect, what does?” she asked.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3291"
    }
  }, [_vm._v("Michael knew what she was about, turning the conversation always to him, his opinions, his preferences, and yet, he liked even the fiction of interest from her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3292"
    }
  }, [_vm._v("Which was not good at all.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3293"
    }
  }, [_vm._v("“I admire honesty, courage, learning, and determination.” "), _c('i', [_vm._v("Says the man bent on deceiving a woman who’s done nothing to deserve the slight.")]), _vm._v(" “What about you?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3294"
    }
  }, [_vm._v("She tore off a chunk of bread, there being no serrated knife on the table. “Honesty is too often counted a virtue, even when it causes an unkind result, and education is largely a privilege of wealthy men. I value compassion, tolerance, and humor. Determination has a place, provided it’s tempered by wisdom. Would you please pass the butter?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3295"
    }
  }, [_vm._v("A lady would have waited until somebody produced the proper sort of bread knife and recalled to pass her the butter rather than make do and speak up. Such ladies likely endured much needless hunger and unbuttered bread.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3296"
    }
  }, [_vm._v("“I’ll trade you,” Michael said, passing over the butter and appropriating the rest of the loaf. “Where do you suppose your companion has got off to?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3297"
    }
  }, [_vm._v("Miss Whitlow dabbed a generous portion of butter onto her bread, considered the result, then added more.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3298"
    }
  }, [_vm._v("“Lucille is exhausted from packing up my household, getting the new tenant settled, and organizing my remove to Oxfordshire. I suspect the poor dear is fast asleep on the sofa in your parlor. I can fetch her down here, if you would rather we have a third at the table.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3299"
    }
  }, [_vm._v("She turned the same gaze on him she’d treated the innkeeper to: feline, amused, and subtly challenging. No wonder princes and dukes had vied for her favors.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3300"
    }
  }, [_vm._v("“I’m sure, Miss Whitlow, that my virtue, or what’s left of it, is safe in your hands. Unless you’re concerned that my behavior will transgress the bounds of your tolerance, we can allow Lucille her rest.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3301"
    }
  }, [_vm._v("She popped a bite of bread into her mouth. “Your virtue, and the virtue of the male of the species generally, is safe from my predation. I’ve retired from that game, not that I ever had to stalk the poor, defenseless male. Behave how you please, provided you don’t expect me to allow the soup to get cold.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3302"
    }
  }, [_c('i', [_vm._v("Henrietta Whitlow had retired?")]), _vm._v(" Michael belonged to several clubs, though not the loftiest or the most expensive. He owned gaming enterprises among other businesses, rubbed shoulders with journalists and Bow Street runners, and remained current on all the gossip as a matter of business necessity.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3303"
    }
  }, [_vm._v("Also, old habit, and he’d heard nothing of her retirement. “Am I the first to learn of this decision?” He’d known she was journeying to Oxford for the holidays, as she had every year for the past five, but not that she’d removed from the capital entirely.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3304"
    }
  }, [_vm._v("She gestured dismissively with the buttered bread. “My comings and goings are hardly news. The soup is good, compared to some I’ve had. Mr. Murphy apparently respects your custom.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3305"
    }
  }, [_vm._v("“Or my coin,” Michael replied, taking a spoonful of steamy beef broth. “May I ask what precipitated your decision to quit London?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3306"
    }
  }, [_vm._v("He ought not to have inquired. The question was personal as hell, and a criminal’s professional detachment was integral to achieving Michael’s objective.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3307"
    }
  }, [_vm._v("“I’m not simply quitting London, my lord, I’m quitting my profession. My reasons are personal, though boredom figured prominently among them.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3308"
    }
  }, [_vm._v("She took a dainty spoonful of soup, when Michael wanted to salute her with his drink. She’d been bored by the amatory attentions of aristocrats and nabobs? Bored by the loveliest jewelry the Ludgate goldsmiths had on offer? Even the king had expressed an interest in furthering his acquaintance with Henrietta Whitlow, without apparent result.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3309"
    }
  }, [_vm._v("On behalf of the male gender, Michael acknowledged a set-down all the more devastating for being offered with casual humor.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3310"
    }
  }, [_vm._v("“Maybe you aren’t bored so much as angry,” he suggested.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3311"
    }
  }, [_vm._v("Miss Whitlow drained her toddy. “My upbringing was such that my temper is seldom in evidence. I do find it tedious when a man who barely knows me presumes to tell me what sentiment holds sway over my heart. Boredom and I are intimately acquainted, my lord. I try to keep my distance from anger.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3312"
    }
  }, [_vm._v("She wrinkled her nose at the dregs in her cup.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3313"
    }
  }, [_vm._v("Michael suspected Henrietta Whitlow’s temper could cinder London, if she ever cut loose, and every red-blooded male over the age of fourteen would line up to admire the spectacle at peril to his own continued existence.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3314"
    }
  }, [_vm._v("Men were idiots, as Michael’s four sisters constantly reminded him. “Shall I order more toddies?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3315"
    }
  }, [_vm._v("“The tea should be along shortly, and my appreciation for a hot, sweet cup of pure gunpowder rivals my love of books.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3316"
    }
  }, [_vm._v("Another surprise. “Books?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3317"
    }
  }, [_vm._v("“You know,” she said, dipping her buttered bread into her soup. “Pages, printing, knowledge, and whacking good stories. Growing up, my brothers were given free run of my father’s library. I was limited to sermons, lest my feeble female brain become overheated with Mr. Crusoe’s adventures. I’ll have the rest of the bread, if you don’t care for it.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3318"
    }
  }, [_vm._v("An Irishman treasured fresh bread and butter almost as much as he favored a good ale. Michael passed her the remains of the loaf.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3319"
    }
  }, [_vm._v("“What’s your favorite book?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3320"
    }
  }, [_vm._v("As they consumed their meal, Miss Whitlow gave up a small clue to her soul: She knew her literature, as did Michael. He’d come late to his letters and had studied learned tomes as a way to compensate for a lack of education. Henrietta Whitlow had a passion for books that had probably stood her in good stead among Oxford graduates and comforted her on those occasions when the Oxford graduates had proven poor company.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3321"
    }
  }, [_vm._v("The maid arrived to clear the plates, a half-grown boy on her heels bearing a tray.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3322"
    }
  }, [_vm._v("“Mrs. Murphy sends along the plum tarts with her compliments,” the maid said, setting a bowl down before Miss Whitlow, then a small blue crock of cream.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3323"
    }
  }, [_vm._v("“How very gracious of her,” Miss Whitlow said as the maid served Michael his portion. “The soup was excellent, and the bread perfect. Please thank everybody from the scullery maid who churned the butter to Mrs. Murphy. The kitchen here is truly a marvel.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3324"
    }
  }, [_vm._v("From across the table, Michael watched as Miss Whitlow offered the maid a smile so purely warm-hearted, the half-grown boy nearly dropped the tray and the serving maid’s curtsey would have flattered a queen. That smile made all right with the world and gave gleeful assurances of happy endings just waiting to come true.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3325"
    }
  }, [_vm._v("Harmon DeWitt, Viscount Beltram, still spoke fondly of that smile, even as he plotted against the woman who bestowed it.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3326"
    }
  }, [_vm._v("“My thanks as well,” Michael said. “Would you be so good as to ensure that Miss Whitlow’s maid has some sustenance? She’s enjoying a respite in the parlor adjoined to my bedchamber.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3327"
    }
  }, [_vm._v("“Certainly, sir. Come along, Gordie.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3328"
    }
  }, [_vm._v("The lad tried for a bow, but kept his gaze on Miss Whitlow the entire time. She winked at the boy as he backed from the room.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3329"
    }
  }, [_vm._v("“You’ll spoil him for all other ladies,” Michael said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3330"
    }
  }, [_vm._v("The smile faded into a brittle light in Miss Whitlow’s eyes. “Good. We should all exercise the greatest discernment when choosing with whom to share our time and our trust. If I’ve preserved him from a few scheming chambermaids—for chambermaids are not to be trusted where juvenile males are concerned—then he’s better off.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3331"
    }
  }, [_vm._v("Nothing in her tone suggested even mild annoyance, and yet, Michael sensed reproof again—no creature on earth was less of a threat to anybody than a harried chambermaid—or…something sadder.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3332"
    }
  }, [_vm._v("Bitterness, perhaps. Well-earned, entirely appropriate bitterness.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3333"
    }
  }, [_vm._v("Happy Christmas, indeed.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0adc94bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/s004-Chapter-001.vue
// module id = 69
// module chunks = 0